package org.example.project.enginekalender

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import org.example.project.dashboard.DashboardTheme
import org.example.project.dashboard.PopupEngineCard
import org.example.project.settings.LumaticaButton
import org.example.project.settings.LumaticaButtonVariant
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun TerminSlotSettingsPopup(
    initialFrom: String,
    initialTo: String,
    initialActiveWeekdays: Set<String>,
    onClose: () -> Unit,
    onSave: (String, String, Set<String>) -> Unit
) {
    var von by remember(initialFrom) { mutableStateOf(initialFrom) }
    var bis by remember(initialTo) { mutableStateOf(initialTo) }
    var activeWeekdays by remember(initialActiveWeekdays) { mutableStateOf(initialActiveWeekdays) }
    val weekdayOrder = listOf("mo", "di", "mi", "do", "fr", "sa", "so")
    val canSave = parseHourMinute(von) != null &&
        parseHourMinute(bis) != null &&
        (parseHourMinute(von) ?: 0) < (parseHourMinute(bis) ?: 0) &&
        activeWeekdays.isNotEmpty()

    PopupEngineCard(
        windowKey = "termin-slot-settings-popup",
        widthPx = 480,
        heightPx = 260,
        initialX = 460.0,
        initialY = 160.0,
        frameBackground = DashboardTheme.POPUP_BG,
        contentBackground = DashboardTheme.POPUP_BG,
        resizable = true,
        onClose = onClose
    ) {
        Div({
            style {
                padding(18.px)
                boxSizing("border-box")
                height(100.percent)
                display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column)
            }
        }) {
            Div({
                style {
                    width(100.percent)
                    height(100.percent)
                    property("background", DashboardTheme.POPUP_BG)
                    borderRadius(18.px)
                    boxSizing("border-box")
                    padding(24.px)
                    display(DisplayStyle.Flex)
                    flexDirection(FlexDirection.Column)
                    gap(18.px)
                }
            }) {
                Span({
                    style {
                        color(Color.white)
                        fontSize(22.px)
                        fontWeight("700")
                    }
                }) { Text("Termin Einstellungen") }

                Div({
                    style {
                        display(DisplayStyle.Flex)
                        gap(12.px)
                        alignItems(AlignItems.FlexEnd)
                    }
                }) {
                    Div({ style { flex(1) } }) {
                        TerminField("Slots von") {
                            Input(InputType.Time, attrs = {
                                value(von)
                                style { terminInputStyle() }
                                onInput { von = it.value }
                            })
                        }
                    }
                    Div({ style { flex(1) } }) {
                        TerminField("bis") {
                            Input(InputType.Time, attrs = {
                                value(bis)
                                style { terminInputStyle() }
                                onInput { bis = it.value }
                            })
                        }
                    }
                }

                Div({
                    style {
                        display(DisplayStyle.Flex)
                        flexWrap(FlexWrap.Wrap)
                        gap(8.px)
                    }
                }) {
                    weekdayOrder.forEach { day ->
                        LumaticaButton(
                            label = day.replaceFirstChar { it.uppercase() },
                            onClick = {
                                activeWeekdays = if (day in activeWeekdays) {
                                    activeWeekdays - day
                                } else {
                                    activeWeekdays + day
                                }
                            },
                            variant = LumaticaButtonVariant.State,
                            isActive = day in activeWeekdays
                        )
                    }
                }

                Span({
                    style {
                        color(DashboardTheme.TEXT_MUTED)
                        fontSize(13.px)
                    }
                }) {
                    Text(
                        if (activeWeekdays.isEmpty()) {
                            "Mindestens ein Tag muss aktiv sein."
                        } else {
                            "Außerhalb dieses Fensters und an deaktivierten Tagen kann nichts gebucht werden."
                        }
                    )
                }

                Div({
                    style {
                        display(DisplayStyle.Flex)
                        justifyContent(JustifyContent.FlexEnd)
                        gap(10.px)
                        property("margin-top", "auto")
                    }
                }) {
                    LumaticaButton("Abbrechen", onClick = onClose, variant = LumaticaButtonVariant.Standard)
                    LumaticaButton(
                        "Speichern",
                        onClick = { onSave(von, bis, activeWeekdays) },
                        variant = LumaticaButtonVariant.Action,
                        enabled = canSave
                    )
                }
            }
        }
    }
}
